// pages/Dashboard.jsx
import ExploreBooksPage from "../../components/home/ExploreBooks";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ExploreBooksPage />
    </HomeLayout>
  );
}
